<div class="modal-header">
  <h4 class="modal-title text-center header-title">{{callFrom== 'view-invoice' ?  'Statement History Details' :'Statement Details'}}</h4>
  <button type="button" class="btn btn-warning btn-lg close-btn" aria-label="Close" (click)="closePopup()">
    <i class="fas fa-window-close"></i>
  </button>
</div>

<div class="scrollable-container">
  @if (callFrom== 'view') {
    <mat-card class="result">
      <mat-card-content>
        <table class="details-table">
          <tr class="t-row">
            <th>Adjustment Error</th>
            <td>{{selectedData.descriptionComment}}</td>
          </tr>
          <tr class="t-row">
            <th>Controls/Corrections</th>
            <td>{{selectedData.controlComment}}</td>
          </tr>
          <tr class="t-row">
            <th>Billed within 6 months</th>
            <td>
              <label class="checkbox-label">
                <input type="checkbox" [checked]="selectedData.billedSixMonths == 1" disabled class="checkbox-text" />Yes
              </label>
              <label class="checkbox-label">
                <input type="checkbox" [checked]="selectedData.billedSixMonths == 2" disabled class="checkbox-text" />No
              </label>
              <label class="checkbox-label">
                <input type="checkbox" [checked]="selectedData.billedSixMonths == 3" disabled class="checkbox-text" />N/A
              </label>
            </td>
          </tr>
          <tr class="t-row">
            <th>Disputed within 6 months</th>
            <td>
              <label class="checkbox-label">
                <input type="checkbox" [checked]="selectedData.disputedSixMonths == 1" disabled class="checkbox-text" />Yes
              </label>
              <label class="checkbox-label">
                <input type="checkbox" [checked]="selectedData.disputedSixMonths == 2" disabled class="checkbox-text" />No
              </label>
              <label class="checkbox-label">
                <input type="checkbox" [checked]="selectedData.disputedSixMonths == 3" disabled class="checkbox-text" />N/A
              </label>
            </td>
          </tr>
          <tr class="t-row">
            <th>Billing Edit required</th>
            <td>
              <label class="checkbox-label">
                <input type="checkbox" [checked]="selectedData.billingEditRequired == 1" disabled class="checkbox-text" />Yes
              </label>
              <label class="checkbox-label">
                <input type="checkbox" [checked]="selectedData.billingEditRequired == 2" disabled class="checkbox-text" />No
              </label>
              <label class="checkbox-label">
                <input type="checkbox" [checked]="selectedData.billingEditRequired == 3" disabled class="checkbox-text" />N/A
              </label>
            </td>
          </tr>
          <tr class="t-row">
            <th>Billing Edit completed</th>
            <td>
              <label class="checkbox-label">
                <input type="checkbox" [checked]="selectedData.billingEditCompleted == 1" disabled class="checkbox-text" />Yes
              </label>
              <label class="checkbox-label">
                <input type="checkbox" [checked]="selectedData.billingEditCompleted == 2" disabled class="checkbox-text" />No
              </label>
              <label class="checkbox-label">
                <input type="checkbox" [checked]="selectedData.billingEditCompleted == 3" disabled class="checkbox-text" />N/A
              </label>
            </td>
          </tr>
          <tr class="t-row">
            <th>Adjustment Reason</th>
            <td>{{selectedData.adjReason}}</td>
          </tr>
        </table>
      </mat-card-content>
    </mat-card>
  }

  @if (!isGoodWillRequest) {
    <div>
      <th class="adjustment-summary-title">Adjustment Summary</th>
      <mat-card class="result">
        <mat-card-content>
          <div class="mat-elevation-z9 table-wrapper">
            <mat-table [dataSource]="panels" class="custom-mat-table">
              @for (column of displayedColumnsSummaryList(); track column) {
                <ng-container [matColumnDef]="column.propertyName">
                  <th mat-header-cell *matHeaderCellDef class="centered-header">{{ column.label }}</th>
                  <td mat-cell *matCellDef="let element"
                    class="centered-cell"
                [ngClass]="{
                  'negative': isNegative(element[column.propertyName]),
                  'ellipsis-cell': (column.propertyName === 'firstLevelRemarks' ||  column.propertyName === 'gbsRemarks' || column.propertyName === 'secondLevelRemarks'),
                }"
                    [matTooltip]="(column.propertyName === 'firstLevelRemarks' ||  column.propertyName === 'gbsRemarks' || column.propertyName === 'secondLevelRemarks') ? element[column.propertyName] : null"
                    matTooltipPosition="above">
                    {{ element[column.propertyName] | emptyFallback:'--' }}
                  </td>
                </ng-container>
              }
              <tr mat-header-row *matHeaderRowDef="invoiceDisplayedColumnSummary"></tr>
              <tr mat-row *matRowDef="let panel of panels; columns: invoiceDisplayedColumnSummary;"></tr>
            </mat-table>
          </div>
        </mat-card-content>
      </mat-card>
    </div>
  }

  @if (isLoading) {
    <div class="col-sm-12 loader-container">
      @if (panels && panels.length > 0) {
        <div>
          <mat-accordion>
            @for (panel of panels; track panel; let i = $index) {
              <mat-expansion-panel (expanded)="onPanelExpanded(panel)">
                <mat-expansion-panel-header class="custom-panel-header">
                  <mat-panel-title> Statement Details {{ i + 1 }}</mat-panel-title>
                </mat-expansion-panel-header>
                <div class="mat-elevation-z8 table-wrapper">
                  <mat-table [dataSource]="[panel]" class="custom-mat-table">
                    @for (column of displayedColumnsList(); track column) {
                      <ng-container [matColumnDef]="column.propertyName">
                        <th mat-header-cell *matHeaderCellDef class="centered-header">{{ column.label }}</th>
                        <td mat-cell *matCellDef="let element" class="centered-cell"
                  [ngClass]="{'negative': isNegative(element[column.propertyName]),
                  'light-blue': ['f25DomMail_Current', 'd49Fsc_Current','d90MinFee_Current','_99Misc_Current','f03Intl_Current'].includes(column.propertyName),
                  'light-green': ['f25DomMail_New', 'd49Fsc_New','d90MinFee_New','_99Misc_New','f03Intl_New'].includes(column.propertyName),
                  'light-red': ['f25DomMail_Adj', 'd49Fsc_Adj','d90MinFee_Adj','_99Misc_Adj','f03Intl_Adj'].includes(column.propertyName)}
                  ">
                          {{ element[column.propertyName] | emptyFallback:'--' }}
                        </td>
                      </ng-container>
                    }
                    <tr mat-header-row *matHeaderRowDef="invoiceDisplayedColumnKeys"></tr>
                    <tr mat-row *matRowDef="let row; columns: invoiceDisplayedColumnKeys;"></tr>
                  </mat-table>
                </div>
              </mat-expansion-panel>
            }
          </mat-accordion>
        </div>
      } @else {
        <div class="no-records">
          <h4>No records available</h4>
        </div>
      }
    </div>
  }
</div>
